/**
 * Global Functionality
 * The logic in this is intended to ONLY contain any functionality
 * that is required on every page load.
 *
 * NOTE: Please do not include any page-specific logic here.
 **/

import Logger from "../lib/logger";
import productBlockBundleWidget from "./ProductBlockBundleWidget";
import SectionMarquee from "./SectionMarquee";
import SectionTestimonialBetterdays from "./SectionTestimonialBetterdays";
import CartGifts from "./CartGifts"; // no need to initiate CartGifts, is custom element

export default function () {
	const NAME = 'Global';
	Logger.info(`${NAME} > loading`);

	// Vars
	// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

	const productBlockBundleWidgetDoms = document.querySelectorAll(`[data-product-block-bundle-widget]`);

	const sectionMarqueeDoms = document.querySelectorAll(`[data-section-marquee]`);

	const testimonialBetterdaysDoms = document.querySelectorAll(`[data-section-testimonial-betterdays]`);

	// Logic
	// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

	/**
	 * init --- Initialization block
	 */
	function init() {
		Logger.info(`${NAME} > init`);
		initproductBlockBundleWidgets();
		initSectionMarquees();
		initTestimonialBetterdays();
	}

	/**
	 * initproductBlockBundleWidgets - Initiailize all fixed price bundle widgets
	 */
	function initproductBlockBundleWidgets() {
		Logger.info(`${NAME} > initproductBlockBundleWidgets`);

		productBlockBundleWidgetDoms.forEach((dom) => {
			const el = new productBlockBundleWidget(dom);
			el.init();
		});
	}

	/**
	 * initSectionMarquees --- Initialize all marquees
	 */
	function initSectionMarquees() {
		Logger.info(`${NAME} > initSectionMarquees`);

		sectionMarqueeDoms.forEach((dom) => {
			const el = new SectionMarquee(dom);
			el.init();
		});
	}

	/**
 * initTestimonialBetterdays
 */
	function initTestimonialBetterdays() {
		Logger.info(`${NAME} > initTestimonialBetterdays`);
		testimonialBetterdaysDoms.forEach((dom) => {
			const el = new SectionTestimonialBetterdays(dom);
			el.init();
		});
	}

	// Do not edit below this line...
	// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
	Logger.info(`${NAME} > loaded`);

	init();
}
